import React, {useContext} from "react";
import {TranslationDomainEnum} from "../../../types/enums";
import {Form, Select, SelectProps} from "antd";
import {Translate} from "../../../components/util/translation.util";
import {StoreContext} from "../../../store.context";

const { Option } = Select;

type Props = {
    name: string,
    label: string,
    choices: Array<{ id: any, name: string }>,
    multiple: boolean,
    translationDomain: TranslationDomainEnum,
    choiceTranslationDomain?: TranslationDomainEnum,
    rules: any,
    onChange?: () => void,
    errors: { [key: string]: string[] },
    data: any,
    validateTrigger?: string,
}

export const EntityType: React.FC<Props> = ({name, label, translationDomain, choiceTranslationDomain, rules, choices, multiple, onChange, validateTrigger= 'onBlur'}) => {
    let selectProps: SelectProps = {};
    const { appStore: {
        translations,
        translate
    } } = useContext(StoreContext);

    if (multiple) {
        selectProps.mode = "multiple";
    }

    return (
        <Form.Item
            labelAlign={`left`}
            name={name.split('.')}
            label={<Translate message={label} domain={translationDomain}/>}
            rules={rules}
            htmlFor={name}
            validateTrigger={validateTrigger}
        >
            <Select
                {...selectProps}
                showSearch
                allowClear
                style={{width: '100%'}}
                placeholder="Please select"
                optionFilterProp="textValue"
                onChange={onChange}
                id={name}
            >
                {
                    choices && choices.map((choice: any, key: number) => {
                        const domain = choiceTranslationDomain ?? translationDomain;
                        const message = choice.name;
                        const itemKey = !translations[domain]?.hasOwnProperty(message) ? message : translate(translations[domain][message], {});

                        return (
                            <Option key={ key } textValue={ itemKey } value={choice.id}>
                                <Translate message={choice.name} domain={choiceTranslationDomain ?? translationDomain}/>
                            </Option>
                        )
                    })
                }
            </Select>
        </Form.Item>
    )
}